import environment from '@/configs/environtment'
import changeImagePathPrefix from '@/utils/helpers/changeImagePathPrefix'
import rupiahFormat from '@/utils/helpers/rupiahFormat'

export const getTransactionTypeLabel = (type?: string): string => {
  if (!type) return '-'
  switch (type) {
    case 'ScanHjCrew':
      return 'Scan Kru HJ'
    case 'ManualInput':
      return 'Input Manual'
    case 'ScanAplikasi':
      return 'Scan Aplikasi'
    default:
      return type
  }
}

export const getFullImageUrl = (path?: string): string => {
  if (!path) return ''
  if (path.startsWith('http://') || path.startsWith('https://')) return path
  const prefixPath = changeImagePathPrefix(path)
  return `${environment.getApiImageBaseUrl()}${prefixPath}`
}

export const formatRupiah = (val?: number): string => {
  if (val === undefined || val === null) return 'Rp 0'
  return rupiahFormat(val)
}
